import { blue, green, indigo, purple, orange, royalBlue } from "./colors";

export const getPrimary = (preset) => {
  switch (preset) {
    case "blue":
      return blue;
    case "royal blue":
      return royalBlue;
    case "green":
      return green;
    case "indigo":
      return indigo;
    case "purple":
      return purple;
    case "orange":
      return orange;
    default:
      console.error(
        'Invalid color preset, accepted values: "blue", "royal blue", "green", "indigo" or "purple"".'
      );
      return blue;
  }
};

export const modalStyle = (lgUp) => {
  return {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: lgUp ? 500 : "90%",
    bgcolor: "background.paper",
    border: "1px solid #9E9E9E",
    borderRadius: 1,
    boxShadow: 24,
    p: 0,
  };
};
